import { render, staticRenderFns } from "./Typography8.vue?vue&type=template&id=50c165ac&scoped=true"
import script from "./Typography8.vue?vue&type=script&lang=js"
export * from "./Typography8.vue?vue&type=script&lang=js"
import style0 from "./Typography8.vue?vue&type=style&index=0&id=50c165ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c165ac",
  null
  
)

export default component.exports